import React, { useState } from 'react';
import { contact, navigation, profile } from '../../data/portfolio';
import './Header.css';

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="site-header">
      <div className="header-inner">
        <a className="identity" href="#about" onClick={closeMenu} aria-label={`${profile.name} 소개로 이동`}>
          <strong>{profile.name}</strong>
          <span>{profile.role}</span>
        </a>

        <button
          className="menu-button"
          type="button"
          aria-expanded={isOpen}
          aria-controls="primary-navigation"
          onClick={() => setIsOpen((current) => !current)}
        >
          <span className="menu-button-label">메뉴</span>
          <span aria-hidden="true">{isOpen ? '닫기' : '열기'}</span>
        </button>

        <nav id="primary-navigation" className={isOpen ? 'primary-nav is-open' : 'primary-nav'} aria-label="주요 메뉴">
          {navigation.map((item) => (
            <a key={item.href} href={item.href} onClick={closeMenu}>
              {item.label}
            </a>
          ))}
          <a href={contact.github} target="_blank" rel="noreferrer" onClick={closeMenu}>
            GitHub
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
